// ODCHUDZONY SECTIONS – tylko meta, zero importów, zero data[]

const sections = [
{
  title: "I. Liczby i działania",
  topics: [
    {
      name: "Systemy zapisywania liczb",
      description:
        "Różne sposoby zapisywania liczb. Na początek system rzymski; kolejne systemy będzie można dodać później.",
      subtopics: [
        { id: "1_12_1", name: "System rzymski" },
      ],
    },

    {
      name: "Liczby naturalne i działania",
      description:
        "Podstawowe działania na liczbach naturalnych, kolejność wykonywania działań, zaokrąglanie i szacowanie.",
      subtopics: [
        { id: "1_7_1", name: "Dodawanie i odejmowanie liczb naturalnych" },
        { id: "1_7_2", name: "Mnożenie liczb naturalnych" },
        { id: "1_7_3", name: "Dzielenie liczb naturalnych" },
        { id: "1_7_4", name: "Kolejność wykonywania działań" },
        { id: "1_7_6", name: "Zaokrąglanie i szacowanie" },
        {
          id: "1_7",
          name: "Quiz zbiorczy",
          type: "quiz",
          standaloneQuiz: true,
        },
      ],
    },

    {
      name: "Działania pisemne",
      description:
        "Algorytmy pisemne dla podstawowych działań arytmetycznych na większych liczbach.",
      subtopics: [
        { id: "1_8_1", name: "Dodawanie pisemne" },
        { id: "1_8_2", name: "Odejmowanie pisemne" },
        { id: "1_8_3", name: "Mnożenie pisemne" },
        { id: "1_8_4", name: "Dzielenie pisemne" },
        {
          id: "1_8",
          name: "Quiz zbiorczy",
          type: "quiz",
          standaloneQuiz: true,
        },
      ],
    },

    {
      name: "Liczby całkowite",
      description:
        "Liczby dodatnie i ujemne na osi liczbowej oraz działania na liczbach całkowitych.",
      subtopics: [
        { id: "1_9_1", name: "Oś liczbowa" },
        { id: "1_9_2", name: "Dodawanie i odejmowanie liczb całkowitych" },
        { id: "1_9_3", name: "Mnożenie liczb całkowitych" },
        { id: "1_9_4", name: "Dzielenie liczb całkowitych" },
        {
          id: "1_9",
          name: "Quiz zbiorczy",
          type: "quiz",
          standaloneQuiz: true,
        },
      ],
    },

    // Teoria liczb -> temat 3 (1_3_*)
    {
      name: "Teoria liczb",
      description: "Podzielność, liczby pierwsze, NWD i NWW.",
      subtopics: [
        { id: "1_3_1", name: "Podzielność liczb całkowitych" },
        { id: "1_3_2", name: "Liczby pierwsze i złożone" },
        {
          id: "1_3_3",
          name:
            "Największy wspólny dzielnik (NWD) i najmniejsza wspólna wielokrotność (NWW)",
        },
        {
          id: "1_3",
          name: "Quiz zbiorczy",
          type: "quiz",
          standaloneQuiz: true,
        },
      ],
    },

    {
      name: "Ułamki zwykłe",
      description:
        "Ułamki zwykłe, liczby mieszane, porównywanie, skracanie, rozszerzanie oraz działania na ułamkach.",
      subtopics: [
        { id: "1_10_1", name: "Ułamki zwykłe i ułamki równoważne" },
        { id: "1_10_6", name: "Ułamki niewłaściwe i liczby mieszane" },
        { id: "1_10_2", name: "Porównywanie ułamków" },
        { id: "1_10_3", name: "Dodawanie i odejmowanie ułamków zwykłych" },
        { id: "1_10_4", name: "Mnożenie ułamków zwykłych" },
        { id: "1_10_5", name: "Dzielenie ułamków zwykłych" },
        { id: "1_10_7", name: "Działania łączne na liczbach wymiernych" },
        {
          id: "1_10",
          name: "Quiz zbiorczy",
          type: "quiz",
          standaloneQuiz: true,
        },
      ],
    },

    {
      name: "Ułamki dziesiętne",
      description:
        "Porównywanie, zaokrąglanie, zamiana oraz działania na ułamkach dziesiętnych.",
      subtopics: [
        { id: "1_11_1", name: "Porównywanie i zaokrąglanie ułamków dziesiętnych" },
        { id: "1_11_2", name: "Dodawanie i odejmowanie ułamków dziesiętnych" },
        { id: "1_11_3", name: "Mnożenie ułamków dziesiętnych" },
        { id: "1_11_4", name: "Dzielenie ułamków dziesiętnych" },
        { id: "1_11_5", name: "Zamiana ułamków zwykłych i dziesiętnych" },
        { id: "1_11_6", name: "Szacowanie i zaokrąglanie wyników" },
        {
          id: "1_11",
          name: "Quiz zbiorczy",
          type: "quiz",
          standaloneQuiz: true,
        },
      ],
    },

    // Procenty -> temat 2 (1_2_*)
    {
      name: "Procenty",
      description:
        "Obliczenia procentowe, zmiany procentowe oraz porównania procentowe.",
      subtopics: [
        { id: "1_2_1", name: "Obliczanie procentów" },
        { id: "1_2_2", name: "Zmiany procentowe" },
        { id: "1_2_3", name: "Procentowe porównania" },
        { id: "1_2_4", name: "Procent składany" },
        {
          id: "1_2",
          name: "Quiz zbiorczy",
          type: "quiz",
          standaloneQuiz: true,
        },
      ],
    },

    {
      name: "Zbiory, wartość bezwzględna i przedziały",
      description:
        "Wartość bezwzględna, podstawowe zbiory oraz opisywanie zbiorów liczbowych przedziałami.",
      subtopics: [
        { id: "1_1_2", name: "Wartość bezwzględna" },
        { id: "1_1_3", name: "Zbiory" },
        { id: "1_1_4", name: "Przedziały" },
        {
          id: "1_1",
          name: "Quiz zbiorczy",
          type: "quiz",
          standaloneQuiz: true,
        },
      ],
    },

    // Potęgi i pierwiastki -> temat 4 (1_4_*)
    {
      name: "Potęgi i pierwiastki",
      description:
        "Własności potęg i pierwiastków oraz zapisy liczb w notacji wykładniczej.",
      subtopics: [
        { id: "1_4_1", name: "Potęgi o wykładniku naturalnym" },
        { id: "1_4_2", name: "Potęgi o wykładniku całkowitym" },
        { id: "1_1_5", name: "Działania na pierwiastkach" },
        {
          id: "1_4_3",
          name: "Potęgi o wykładniku wymiernym i pierwiastki",
        },
        { id: "1_4_4", name: "Notacja wykładnicza" },
        {
          id: "1_4",
          name: "Quiz zbiorczy",
          type: "quiz",
          standaloneQuiz: true,
        },
      ],
    },

    // Logarytmy -> temat 5 (1_5_*)
    {
      name: "Logarytmy",
      description: "Definicja, własności oraz równania logarytmiczne.",
      subtopics: [
        { id: "1_5_1", name: "Definicja logarytmu" },
        { id: "1_5_2", name: "Własności logarytmów" },
        { id: "1_5_3", name: "Obliczanie logarytmów" },
        {
          id: "1_5",
          name: "Quiz zbiorczy",
          type: "quiz",
          standaloneQuiz: true,
        },
      ],
    },

    {
      name: "Zadania uzupełniające / egzaminacyjne",
      description:
        "Zadania uzupełniające oraz zadania maturalne i E8.",
      subtopics: [
        { id: "1_6_1", name: "Uzupełniające" },
        { id: "1_6_2", name: "Maturalne – zamknięte" },
        //{ id: "1_6_3", name: "Maturalne – otwarte" },
        { id: "1_6_4", name: "E8 – zamknięte" },
        { id: "1_6_5", name: "E8 – otwarte" },
      ],
    },
  ],
},


  

  {
    title: "II. Algebra",
    topics: [
      {
        name: "Wyrażenia algebraiczne",
        description:
          "Upraszczanie wyrażeń, wzory skróconego mnożenia i ułamki algebraiczne.",
        subtopics: [
          { id: "2_1_1", name: "Upraszczanie wyrażeń algebraicznych" },
          { id: "2_1_2", name: "Wzory skróconego mnożenia" },
          { id: "2_1_3", name: "Ułamki algebraiczne" },
          //{ id: "2_1_4", name: "Działania na wielomianach" },
          {
            id: "2_1",
            name: "Quiz zbiorczy",
            type: "quiz",
            standaloneQuiz: true,
          },
        ],
      },

      {
        name: "Wielomiany",
        description:
          "Poj\u0119cie wielomianu, dzia\u0142ania na wielomianach, rozk\u0142ad na czynniki i r\u00f3wnania wielomianowe.",
        subtopics: [
          { id: "2_7_1", name: "Poj\u0119cie wielomianu" },
          { id: "2_7_2", name: "Dzia\u0142ania na wielomianach" },
          { id: "2_7_3", name: "Rozk\u0142ad wielomianu na czynniki" },
          { id: "2_7_4", name: "R\u00f3wnania wielomianowe" },
        ],
      },

      {
        name: "Równania",
        description: "Równania liniowe, kwadratowe, wymierne i wielomianowe.",
        subtopics: [
          { id: "2_2_1", name: "Równania liniowe" },
          { id: "2_2_2", name: "Równania kwadratowe" },
          { id: "2_2_3", name: "Równania wymierne" },
          { id: "2_2_4", name: "Równania z wartością bezwzględną" },
          { id: "2_2_6", name: "R\u00f3wnania z warto\u015bci\u0105 bezwzgl\u0119dn\u0105 - rozszerzenie", level: "extended" },
          { id: "2_2_5", name: "Równania wielomianowe" },
          {
            id: "2_2",
            name: "Quiz zbiorczy",
            type: "quiz",
            standaloneQuiz: true,
          },
        ],
      },

      {
        name: "Wzory i zależności",
        description:
          "Podstawianie do wzorów, przekształcanie wzorów oraz praktyczne zależności.",
        subtopics: [
          { id: "2_6_1", name: "Podstawianie do wzorów" },
          { id: "2_6_2", name: "Przekształcanie wzorów" },
          { id: "2_6_3", name: "Prędkość, droga, czas" },
        ],
      },

      {
        name: "Nierówności",
        description:
          "Nierówności liniowe, kwadratowe oraz z wartością bezwzględną.",
        subtopics: [
          { id: "2_3_1", name: "Nierówności liniowe" },
          { id: "2_3_2", name: "Nierówności kwadratowe" },
          { id: "2_3_3", name: "Nierówności z wartością bezwzględną" },
          { id: "2_3_4", name: "Nier\u00f3wno\u015bci z warto\u015bci\u0105 bezwzgl\u0119dn\u0105 - rozszerzenie", level: "extended" },
          {
            id: "2_3",
            name: "Quiz zbiorczy",
            type: "quiz",
            standaloneQuiz: true,
          },
        ],
      },

      {
        name: "Układy równań",
        description: "Metoda podstawiania i metoda przeciwnych współczynników.",
        subtopics: [
          { id: "2_4_1", name: "Układy równań liniowych" },
          { id: "2_4_2", name: "Zadania tekstowe" },
          { id: "2_4_3", name: "Układy równań liniowe i kwadratowe" },
          {
            id: "2_4",
            name: "Quiz zbiorczy",
            type: "quiz",
            standaloneQuiz: true,
          },
        ],
      },

      {
        name: "Zadania uzupełniające / maturalne",
        description:
          "Zadania uzupełniające oraz zadania maturalne zamknięte i otwarte.",
        subtopics: [
          { id: "2_5_1", name: "Uzupełniające" },
          { id: "2_5_2", name: "Maturalne – zamknięte" },
          { id: "2_5_3", name: "Maturalne – otwarte" },
          { id: "2_5_4", name: "Maturalne – rozszerzenie" },
          { id: "2_5_5", name: "E8 – zamknięte" },
          { id: "2_5_6", name: "E8 – otwarte" },
        ],
      },
    ],
  },

  {
    title: "III. Funkcje",
    topics: [
      {
        name: "Własności funkcji",
        description: "Pojęcie, wykres, dziedzina, zbiór wartości i podstawowe własności funkcji.",
        subtopics: [
          { id: "3_1_1", name: "Pojęcie funkcji" },
          { id: "3_1_2", name: "Wykres funkcji" },
          { id: "3_1_3", name: "Dziedzina i zbiór wartości" },
          { id: "3_1_4", name: "Miejsca zerowe i monotoniczność" },
          { id: "3_1_5", name: "Funkcje szczególne" },
          { id: "3_1_6", name: "Przekształcenia wykresów funkcji" },
          {
            id: "3_1",
            name: "Quiz zbiorczy",
            type: "quiz",
            standaloneQuiz: true,
          },
        ],
      },

      {
        name: "Przekształcenia funkcji",
        description:
          "Wektory, przesunięcia, symetrie oraz rozszerzeniowe przekształcenia wykresów.",
        subtopics: [
          { id: "3_8_1", name: "Wektory" },
          { id: "3_8_2", name: "Przesunięcia wykresu" },
          { id: "3_8_3", name: "Symetrie wykresu" },
          { id: "3_8_4", name: "Wartość bezwzględna", level: "extended" },
          { id: "3_8_5", name: "Skalowanie wykresu", level: "extended" },
          {
            id: "3_8",
            name: "Przekształcenia wykresów funkcji - podsumowanie",
          },
        ],
      },

      {
        name: "Proporcjonalność",
        description: "Proporcjonalność prosta i odwrotna, tabele oraz zależności między wielkościami.",
        subtopics: [
          { id: "3_9_1", name: "Proporcjonalność odwrotna" },
        ],
      },
      {
        name: "Funkcja liniowa",
        description:
          "Postać wzoru funkcji liniowej, wykres oraz proste zadania tekstowe.",
        subtopics: [
          { id: "3_2_1", name: "Wzór funkcji liniowej" },
          { id: "3_2_2", name: "Wykres funkcji liniowej" },
          { id: "3_2_3", name: "Zadania tekstowe" },
          {
            id: "3_2",
            name: "Quiz zbiorczy",
            type: "quiz",
            standaloneQuiz: true,
          },
        ],
      },

      {
        name: "Funkcja kwadratowa",
        description:
          "Różne postaci wzoru funkcji kwadratowej, wykres, równania i nierówności kwadratowe oraz zadania optymalizacyjne.",
        subtopics: [
          { id: "3_3_1", name: "Postać ogólna" },
          { id: "3_3_2", name: "Postać kanoniczna" },
          { id: "3_3_3", name: "Postać iloczynowa" },
          { id: "3_3_4", name: "Równania kwadratowe" },
          { id: "3_3_5", name: "Nierówności kwadratowe" },
          { id: "3_3_6", name: "Optymalizacja" },
          { id: "3_3_7", name: "Równania kwadratowe z parametrem i wzory Viète’a" },
          {
            id: "3_3",
            name: "Quiz zbiorczy",
            type: "quiz",
            standaloneQuiz: true,
          },
        ],
      },

      /*{
        name: "Funkcja wymierna",
        description:
          "Definicja funkcji wymiernej, dziedzina, asymptoty i własności wykresu.",
        subtopics: [
          { id: "3_4_1", name: "Definicja" },
          { id: "3_4_2", name: "Asymptoty" },
          { id: "3_4_3", name: "Dziedzina i miejsca zerowe" },
          {
            id: "3_4",
            name: "Quiz zbiorczy",
            type: "quiz",
            standaloneQuiz: true,
          },
        ],
      },
      */

      /*{
        name: "Funkcja wykładnicza i logarytmiczna",
        description:
          "Własności funkcji wykładniczej i logarytmicznej oraz proste równania z ich udziałem.",
        subtopics: [
          { id: "3_5_1", name: "Funkcja wykładnicza" },
          { id: "3_5_2", name: "Funkcja logarytmiczna" },
          { id: "3_5_3", name: "Związki" },
          {
            id: "3_5",
            name: "Quiz zbiorczy",
            type: "quiz",
            standaloneQuiz: true,
          },
        ],
      },
      */

      {
        name: "Zadania uzupełniające / maturalne",
        description:
          "Zadania uzupełniające oraz zadania maturalne zamknięte i otwarte.",
        subtopics: [
          { id: "3_6_1", name: "Uzupełniające" },
          { id: "3_6_2", name: "Maturalne – zamknięte" },
          { id: "3_6_3", name: "Maturalne – otwarte" },
          { id: "3_6_4", name: "Maturalne – rozszerzenie" },
        ],
      },
      {
        name: "Analiza matematyczna",
        description:
          "Pochodna funkcji, styczna do wykresu, ekstrema oraz zadania optymalizacyjne.",
        subtopics: [
          { id: "3_7_1", name: "Pochodna" },
          { id: "3_7_2", name: "Styczna do wykresu funkcji" },
          { id: "3_7_3", name: "Ekstrema funkcji" },
          { id: "3_7_4", name: "Zadania optymalizacyjne" },
          {
            id: "3_7",
            name: "Quiz zbiorczy",
            type: "quiz",
            standaloneQuiz: true,
          },
        ],
      },
      {
        name: "Funkcja wykładnicza i logarytmiczna",
        description: "Własności i zastosowania funkcji wykładniczej oraz logarytmicznej.",
        subtopics: [
          { id: "3_5_1", name: "Funkcja wykładnicza" },
          { id: "3_5_2", name: "Funkcja logarytmiczna" },
          { id: "3_5_3", name: "Związki" },
        ],
      },
    ],
  },

  {
    title: "IV. Ciągi",
    topics: [
      {
        name: "Ciągi ogólne",
        description: "Definicja, własności oraz ciągi rekurencyjne.",
        subtopics: [
          { id: "4_1_1", name: "Definicja ciągu" },
          { id: "4_1_2", name: "Monotoniczność ciągów" },
          { id: "4_1_3", name: "Ciągi rekurencyjne" },
          {
            id: "4_1",
            name: "Quiz zbiorczy",
            type: "quiz",
            standaloneQuiz: true,
          },
        ],
      },

      {
        name: "Ciąg arytmetyczny",
        description: "Definicja, wzory oraz zadania tekstowe.",
        subtopics: [
          { id: "4_2_1", name: "Ciąg arytmetyczny – definicja" },
          { id: "4_2_2", name: "Suma ciągu arytmetycznego" },
          { id: "4_2_3", name: "Zadania tekstowe" },
          {
            id: "4_2",
            name: "Quiz zbiorczy",
            type: "quiz",
            standaloneQuiz: true,
          },
        ],
      },

      {
        name: "Ciąg geometryczny",
        description: "Definicja, suma i zastosowania.",
        subtopics: [
          { id: "4_3_1", name: "Ciąg geometryczny – definicja" },
          { id: "4_3_2", name: "Suma ciągu geometrycznego" },
          { id: "4_3_3", name: "Procent składany" },
          { id: "4_3_4", name: "Zadania tekstowe" },
          {
            id: "4_3",
            name: "Quiz zbiorczy",
            type: "quiz",
            standaloneQuiz: true,
          },
        ],
      },

      {
        name: "Zadania uzupełniające / maturalne",
        description:
          "Zadania uzupełniające oraz zadania maturalne zamknięte i otwarte.",
        subtopics: [
          { id: "4_4_1", name: "Uzupełniające" },
          { id: "4_4_2", name: "Maturalne – zamknięte" },
          { id: "4_4_3", name: "Maturalne – otwarte" },
        ],
      },
    ],
  },

  {
    title: "V. Trygonometria",
    topics: [
      {
        name: "Trygonometria kąta ostrego",
        description:
          "Trygonometria w trójkącie prostokątnym – definicje, wartości i zastosowania.",
        subtopics: [
          { id: "5_1_1", name: "Definicje w trójkącie prostokątnym" },
          { id: "5_1_2", name: "Wartości trygonometryczne kątów ostrych" },
          { id: "5_1_3", name: "Zastosowania trygonometrii" },
          {
            id: "5_1_5",
            name: "Rozwiązywanie trójkąta prostokątnego",
          },
          {
            id: "5_1_4",
            name: "Tożsamości trygonometryczne w trójkącie prostokątnym",
          },
          {
            id: "5_1",
            name: "Quiz zbiorczy",
            type: "quiz",
            standaloneQuiz: true,
          },
        ],
      },

      {
        name: "Trygonometria kąta wypukłego (0°–180°)",
        description:
          "Definicje funkcji trygonometrycznych w układzie współrzędnych oraz zależności dla kątów ostrych i rozwartych.",
        subtopics: [
          { id: "5_2_1", name: "Definicja w układzie współrzędnych" },
          { id: "5_2_2", name: "Wzory redukcyjne" },
          { id: "5_2_3", name: "Tożsamości trygonometryczne" },
          {
            id: "5_2",
            name: "Quiz zbiorczy",
            type: "quiz",
            standaloneQuiz: true,
          },
        ],
      },

      {
        name: "Równania trygonometryczne",
        description:
          "Odczytywanie rozwiązań z wykresu, proste przekształcenia i równania wymagające użycia wzorów trygonometrycznych.",
        subtopics: [
          {
            id: "5_3_1",
            name: "Część 1 – odczyt z wykresu i proste równania",
            level: "extended",
          },
          {
            id: "5_3_2",
            name: "Część 2 – równania ze wzorami",
            level: "extended",
          },
        ],
      },

      {
        name: "Zadania uzupełniające / maturalne",
        description:
          "Zadania uzupełniające oraz zadania maturalne zamknięte i otwarte.",
        subtopics: [
          { id: "5_4_1", name: "Uzupełniające" },
          { id: "5_4_2", name: "Maturalne – zamknięte" },
          { id: "5_4_3", name: "Maturalne – otwarte" },
          { id: "5_4_4", name: "Maturalne – rozszerzenie" },
        ],
      },
    ],
  },


  {
    title: "VI. Planimetria",
    topics: [
      {
        name: "Trójkąty",
        description: "Własności, pola, promienie, szczególne trójkąty.",
        subtopics: [
          { id: "6_1_1", name: "Własności trójkątów" },
          { id: "6_1_2", name: "Pole trójkąta" },
          { id: "6_1_3", name: "Promienie w trójkątach" },
          { id: "6_1_4", name: "Trójkąt prostokątny" },
          { id: "6_1_5", name: "Trójkąt równoboczny" },
          { id: "6_1_6", name: "Kąty w trójkątach" },
          { id: "6_1_7", name: "Twierdzenie Talesa i podobieństwo trójkątów" },
          { id: "6_1_8", name: "Twierdzenie sinusów" },
          { id: "6_1_9", name: "Twierdzenie cosinusów" },
          { id: "6_1_10", name: "Twierdzenie o dwusiecznej kąta w trójkącie" },
          {
            id: "6_1",
            name: "Quiz zbiorczy",
            type: "quiz",
            standaloneQuiz: true,
          },
        ],
      },

      {
        name: "Czworokąty",
        description: "Własności czworokątów i pola figur.",
        subtopics: [
          { id: "6_2_1", name: "Prostokąty i kwadraty" },
          { id: "6_2_2", name: "Równoległoboki i romby" },
          { id: "6_2_3", name: "Trapezy" },
          { id: "6_2_4", name: "Kąty w czworokątach" },
          {
            id: "6_2",
            name: "Quiz zbiorczy",
            type: "quiz",
            standaloneQuiz: true,
          },
        ],
      },

      {
        name: "Okręgi i koła",
        description: "Elementy okręgu i koła, styczne i sieczne.",
        subtopics: [
          { id: "6_3_1", name: "Elementy okręgu i koła" },
          { id: "6_3_2", name: "Kąty i styczne" },
          { id: "6_3_3", name: "Odcinki stycznych i siecznych" },
          {
            id: "6_3",
            name: "Quiz zbiorczy",
            type: "quiz",
            standaloneQuiz: true,
          },
        ],
      },

      {
        name: "Jednostki, skala i podobieństwo",
        description:
          "Zamiana jednostek, skala rysunków i map, podobieństwo figur oraz zależności między długościami, obwodami i polami.",
        subtopics: [
          { id: "6_5_4", name: "Jednostki i zamiana jednostek" },
          { id: "6_5_1", name: "Skala" },
          { id: "6_5_2", name: "Podobieństwo figur" },
          { id: "6_5_3", name: "Stosunek pól i objętości figur i brył podobnych" },
          {
            id: "6_5",
            name: "Quiz zbiorczy",
            type: "quiz",
            standaloneQuiz: true,
          },
        ],
      },

      {
        name: "Kąty",
        description:
          "Zależności między kątami, kąty w trójkątach, czworokątach i okręgach.",
        subtopics: [
          { id: "6_6_1", name: "Zależności między kątami" },
          { id: "6_6_2", name: "Kąty w trójkątach" },
          { id: "6_6_3", name: "Kąty w czworokątach" },
          { id: "6_6_4", name: "Kąty w okręgu" },
          {
            id: "6_6",
            name: "Quiz zbiorczy",
            type: "quiz",
            standaloneQuiz: true,
          },
        ],
      },

      {
        name: "Zadania uzupełniające / maturalne",
        description:
          "Zadania uzupełniające oraz zadania maturalne zamknięte i otwarte.",
        subtopics: [
          { id: "6_4_1", name: "Uzupełniające" },
          { id: "6_4_2", name: "Maturalne – zamknięte" },
          { id: "6_4_3", name: "Maturalne – otwarte" },
          { id: "6_4_4", name: "E8 – otwarte" },
          { id: "6_4_5", name: "E8 – zamknięte" },
        ],
      },
    ],
  },

  {
    title: "VII. Geometria analityczna",
    topics: [
      {
        name: "Punkty i odcinki",
        description: "Współrzędne punktów, odległości i symetrie.",
        subtopics: [
          { id: "7_1_1", name: "Współrzędne" },
          { id: "7_1_5", name: "Wektory" },
          { id: "7_1_2", name: "Odległość punktów" },
          { id: "7_1_3", name: "Środek odcinka" },
          { id: "7_1_4", name: "Symetrie" },
          {
            id: "7_1",
            name: "Quiz zbiorczy",
            type: "quiz",
            standaloneQuiz: true,
          },
        ],
      },

      {
        name: "Prosta na płaszczyźnie",
        description: "Równania prostej i położenie wzajemne prostych.",
        subtopics: [
          { id: "7_2_1", name: "Postać kierunkowa" },
          { id: "7_2_2", name: "Postać ogólna" },
          { id: "7_2_3", name: "Położenie prostych" },
          {
            id: "7_2",
            name: "Quiz zbiorczy",
            type: "quiz",
            standaloneQuiz: true,
          },
        ],
      },

      {
        name: "Równanie okręgu",
        description: "Równania okregu w postaci kanonicznej i ogolnej oraz położenie okręgu względem punktu, prostej i drugiego okręgu.",
        subtopics: [
          { id: "7_3_1", name: "Postać kanoniczna" },
          { id: "7_3_2", name: "Postać ogólna" },
          { id: "7_3_3", name: "Położenie okręgu" },
          {
            id: "7_3",
            name: "Quiz zbiorczy",
            type: "quiz",
            standaloneQuiz: true,
          },
        ],
      },

      {
        name: "Figury w układzie współrzędnych",
        description:
          "Własności trójkątów i innych figur opisywanych za pomocą współrzędnych.",
        subtopics: [
          { id: "7_4_1", name: "Trójkąt w układzie współrzędnych" },
        ],
      },

      {
        name: "Zadania uzupełniające / maturalne",
        description:
          "Zadania uzupełniające oraz zadania maturalne zamknięte i otwarte.",
        subtopics: [
          { id: "7_5_1", name: "Uzupełniające" },
          { id: "7_5_2", name: "Maturalne – zamknięte" },
          { id: "7_5_3", name: "Maturalne – otwarte" },
          { id: "7_5_4", name: "E8 – zamknięte" },
        ],
      },
    ],
  },

  {
    title: "VIII. Stereometria",
    topics: [
      {
        name: "Graniastosłupy",
        description:
          "Własności, pola, objętości i przekroje graniastosłupów.",
        subtopics: [
          { id: "8_1_1", name: "Własności graniastosłupów" },
          { id: "8_1_2", name: "Pole graniastosłupów" },
          { id: "8_1_3", name: "Objętość graniastosłupów" },
          //{ id: "8_1_4", name: "Przekroje graniastosłupów" },
          {
            id: "8_1",
            name: "Quiz zbiorczy",
            type: "quiz",
            standaloneQuiz: true,
          },
        ],
      },

      {
        name: "Ostrosłupy",
        description:
          "Własności, pola, objętości i przekroje ostrosłupów.",
        subtopics: [
          { id: "8_2_1", name: "Własności ostrosłupów" },
          { id: "8_2_2", name: "Pole ostrosłupów" },
          { id: "8_2_3", name: "Objętość ostrosłupów" },
          //{ id: "8_2_4", name: "Przekroje ostrosłupów" },
          {
            id: "8_2",
            name: "Quiz zbiorczy",
            type: "quiz",
            standaloneQuiz: true,
          },
        ],
      },

      {
        name: "Bryły obrotowe",
        description: "Własności walca, stożka i kuli.",
        subtopics: [
          { id: "8_3_1", name: "Walec" },
          { id: "8_3_2", name: "Stożek" },
          { id: "8_3_3", name: "Kula" },
          {
            id: "8_3",
            name: "Quiz zbiorczy",
            type: "quiz",
            standaloneQuiz: true,
          },
        ],
      },

      {
        name: "Zadania uzupełniające / maturalne",
        description:
          "Zadania uzupełniające oraz zadania maturalne zamknięte i otwarte.",
        subtopics: [
          { id: "8_4_1", name: "Uzupełniające" },
          { id: "8_4_2", name: "Maturalne – zamknięte" },
          { id: "8_4_3", name: "Maturalne – otwarte" },
          { id: "8_4_4", name: "E8 – otwarte" },
          { id: "8_4_5", name: "E8 – zamknięte" },
        ],
      },
    ],
  },

  {
    title: "IX. Prawdopodobieństwo i statystyka",
    topics: [
      {
        name: "Kombinatoryka",
        description: "Permutacje, wariacje i kombinacje.",
        subtopics: [
          { id: "9_1_1", name: "Zasada mnożenia i dodawania" },
          { id: "9_1_2", name: "Permutacje" },
          { id: "9_1_3", name: "Wariacje" },
          { id: "9_1_4", name: "Kombinacje" },
          {
            id: "9_1",
            name: "Quiz zbiorczy",
            type: "quiz",
            standaloneQuiz: true,
          },
        ],
      },

      {
        name: "Prawdopodobieństwo klasyczne",
        description: "Zdarzenia, prawdopodobieństwa i własności.",
        subtopics: [
          { id: "9_2_1", name: "Podstawy rachunku prawdopodobieństwa" },
          { id: "9_2_2", name: "Zastosowania kombinatoryki" },
          { id: "9_2_3", name: "Zdarzenia i ich własności" },
          {
            id: "9_2",
            name: "Quiz zbiorczy",
            type: "quiz",
            standaloneQuiz: true,
          },
        ],
      },

      {
        name: "Statystyka opisowa",
        description: "Średnie, mediana i dominanta oraz miary zmienności.",
        subtopics: [
          { id: "9_3_1", name: "Średnie" },
          { id: "9_3_2", name: "Położenie i zmienność" },
          { id: "9_3_3", name: "Odczytywanie danych z diagramów" },
          {
            id: "9_3",
            name: "Quiz zbiorczy",
            type: "quiz",
            standaloneQuiz: true,
          },
        ],
      },

      {
        name: "Zadania uzupełniające / maturalne",
        description:
          "Zadania uzupełniające oraz zadania maturalne zamknięte i otwarte.",
        subtopics: [
          { id: "9_4_1", name: "Uzupełniające" },
          { id: "9_4_2", name: "Maturalne – zamknięte" },
          { id: "9_4_3", name: "Maturalne – otwarte" },
          { id: "9_4_4", name: "Maturalne – rozszerzenie" },
          { id: "9_4_5", name: "E8 – zamknięte" },
        ],
      },
    ],
  },

  {
    title: "X. Dowody matematyczne",
    topics: [
      {
        name: "Dowody w arytmetyce",
        description: "Dowody podzielności, równości i nierówności.",
        subtopics: [
          { id: "10_1_1", name: "Dowody podzielności" },
          { id: "10_1_2", name: "Dowody równości i nierówności" },
          { id: "10_1_3", name: "Indukcja matematyczna" },
          {
            id: "10_1",
            name: "Quiz zbiorczy",
            type: "quiz",
            standaloneQuiz: true,
          },
        ],
      },

      {
        name: "Dowody geometryczne",
        description: "Dowody w planimetrii i stereometrii.",
        subtopics: [
          { id: "10_2_1", name: "Planimetria – dowody figur" },
          { id: "10_2_2", name: "Planimetria – dowody kątów" },
          { id: "10_2_3", name: "Dowody stereometryczne" },
          {
            id: "10_2",
            name: "Quiz zbiorczy",
            type: "quiz",
            standaloneQuiz: true,
          },
        ],
      },

      {
        name: "Zadania uzupełniające / maturalne",
        description:
          "Zadania uzupełniające oraz zadania maturalne zamknięte i otwarte.",
        subtopics: [
          { id: "10_3_1", name: "Uzupełniające" },
         // { id: "10_3_2", name: "Maturalne – zamknięte" },
          { id: "10_3_3", name: "Maturalne – otwarte" },
        ],
      },
    ],
  },

];

// ✅ Aliasowanie starych taskId → nowe taskId (dla kompatybilności postępu)
// Używamy tego przy ODCZYCIE postępu w panelu ucznia (StudentDashboard).
export const PROGRESS_ID_ALIASES = {
  // Stare mapowanie tematów w dziale 1:
  // kiedyś: 1_2 = Potęgi, 1_3 = Logarytmy, 1_4 = Procenty, 1_5 = Teoria liczb
  // teraz:  1_2 = Procenty, 1_3 = Teoria liczb, 1_4 = Potęgi, 1_5 = Logarytmy

  // tematy (quizy zbiorcze)
  "1_2": "1_4",
  "1_3": "1_5",
  "1_4": "1_2",
  "1_5": "1_3",

  // podtematy (lekcje)
  "1_2_1": "1_4_1",
  "1_2_2": "1_4_2",
  "1_2_3": "1_4_3",
  "1_2_4": "1_4_4",

  "1_3_1": "1_5_1",
  "1_3_2": "1_5_2",
  "1_3_3": "1_5_3",

  "1_4_1": "1_2_1",
  "1_4_2": "1_2_2",
  "1_4_3": "1_2_3",

  "1_5_1": "1_3_1",
  "1_5_2": "1_3_2",
  "1_5_3": "1_3_3",

  // Roboczy dział XI -> kanoniczne ułamki dziesiętne w dziale I
  "11_1_1": "1_11_2",
  "11_1_2": "1_11_3",
  "11_1_3": "1_11_4",
  "11_1_4": "1_11_6",
};

export default sections;
